function NavButtons({ onBack, onNext, nextDisabled = false, showBack = true, showNext = true }) {
  return (
    <div className="nav-buttons">
      {showBack && (
        <button className="btn btn-secondary" onClick={onBack}>
          Back
        </button>
      )}
      {showNext && (
        <button
          className="btn btn-primary"
          onClick={onNext}
          disabled={nextDisabled}
        >
          Next
        </button>
      )}
    </div>
  );
}

export default NavButtons;
